import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import { MatDialog } from '@angular/material';
import { NavItem } from '../../models/nav-item';

@Component({
    selector: 'app-menu-item-contract',
    template: require('./menu-item-contract.component.html')
})
export class MenuItemContractComponent implements OnInit {
  @Input() items: NavItem[];
  @ViewChild('childMenu') public childMenu;

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/menu-item/menu-item-contract.component.ts